import { PanelConfig } from './PANEL-CONFIG';
import { usePanelStore } from './store';

export const toggleGlobalPanel = (panelId: PanelConfig) => {
  usePanelStore.getState().setOpenGlobalPanel(panelId, (prevState) => !prevState);
};
export const closeGlobalPanel = (panelId: PanelConfig) => {
  usePanelStore.getState().setOpenGlobalPanel(panelId, false);
};
export const openGlobalPanel = (panelId: PanelConfig) => {
  usePanelStore.getState().setOpenGlobalPanel(panelId, true);
};
export const isGlobalPanelOpen = (panelId: PanelConfig) => {
  return !!usePanelStore.getState().openGlobalPanels[panelId];
};

export const enableForceTray = () => {
  usePanelStore.getState().setForceTray(true);
};

export const disableForceTray = () => {
  usePanelStore.getState().setForceTray(false);
};

export const toggleForceTray = () => {
  const currentState = usePanelStore.getState().forceTray;
  usePanelStore.getState().setForceTray(!currentState);
};

export const isForceTrayEnabled = () => {
  return usePanelStore.getState().forceTray;
};

export const GlobalPanel = {
  toggle: toggleGlobalPanel,
  close: closeGlobalPanel,
  open: openGlobalPanel,
  isOpen: isGlobalPanelOpen,
};

export const openPanelInFullscreen = (panelId: PanelConfig) => {
  usePanelStore.getState().setFullScreenPanelId(panelId);
};

export const closeFullscreenPanel = () => {
  usePanelStore.getState().setFullScreenPanelId(null);
};

export const isFullscreenPanelOpen = () => {
  return !!usePanelStore.getState().fullscreenPanelId;
};

export const FullscreenPanel = {
  open: openPanelInFullscreen,
  close: closeFullscreenPanel,
  isOpen: isFullscreenPanelOpen,
};

export const PanelEngine = {
  enableForceTray,
  disableForceTray,
  toggleForceTray,
  isForceTrayEnabled,
};
